import React from 'react';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { DEBRIEF_TITLE_BY_PARTICIPANT } from './SendoutInterviewDebriefDrawer.constants';

export const SendoutInterviewDebriefEditDrawer = ({ onClose = () => {}, participant }) => (
  <FPDrawer
    FPDrawerProps={{ open: true }}
    CardHeaderProps={{ title: DEBRIEF_TITLE_BY_PARTICIPANT[participant] }}
    footer={
      <FPButtonBuilder
        GridContainerProps={{ spacing: 2 }}
        buttonDefinitions={[
          {
            props: {
              text: strings.shared.ui.close,
              variant: 'outlined',
              onClick: onClose
            },
            GridItemProps: { md: 3 }
          },
          {
            props: {
              text: strings.shared.ui.update,
              variant: 'contained',
              disabled: true
            },
            GridItemProps: { md: 3 }
          }
        ]}
      />
    }
    onClose={onClose}
  >
    <div />
  </FPDrawer>
);
